import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'case', standalone: true })
export class CasePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private localeId: string) {}

  transform(value: string | null | undefined, type: 'upper' | 'lower' | 'title' | 'sentence' | 'camel' = 'upper', language = 'tr-TR'): string {
    if (!value) {
      return '';
    }

    language = language ?? this.localeId;

    switch (type) {
      case 'lower':
        return value.toLocaleLowerCase(language);
      case 'title':
        return value.toLocaleLowerCase(language).replace(/(^|\s)\S/g, (c) => c.toLocaleUpperCase(language));
      case 'sentence':
        return value.toLocaleLowerCase(language).replace(/(^|[.?!]\s+)\S/g, (c) => c.toLocaleUpperCase(language));
      case 'camel':
        return value.toLocaleLowerCase(language).replace(/[\s_-]+(\S)/g, (match, p1) => p1.toLocaleUpperCase(language));
      default:
        return value.toLocaleUpperCase(language);
    }
  }
}
